"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _propTypes2 = require("../helpers/prop-types");
var _colors = require("../helpers/colors");
var _reactVis = require("react-vis");
var _empty = require("./empty");
require("react-vis/dist/style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultColorScale = (0, _colors.colorScaleCategorical)();
var LineChart = /*#__PURE__*/function (_Component) {
  _inherits(LineChart, _Component);
  var _super = _createSuper(LineChart);
  function LineChart() {
    var _this;
    _classCallCheck(this, LineChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hoveredValue: undefined
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTooltipAnchor", function (values) {
      // an invisible to anchor tooltips, instead of triggering onNearestX on every series
      // this invisible series fill all gaps that individual series may have
      // x should cover union of all x, y should be average of all y
      var allX = [],
        allY = [];
      values.forEach(function (group) {
        group.forEach(function (bar) {
          allX.push(bar.x);
          allY.push(bar.y);
        });
      });
      var y = allY.reduce(function (p, c) {
        return p + c;
      }, 0) / allY.length;
      var anchors = _toConsumableArray(new Set(allX)).sort().map(function (x) {
        return {
          x: x,
          y: y,
          color: "#FFF"
        };
      });
      return /*#__PURE__*/_react.default.createElement(_reactVis.LineMarkSeries, {
        data: anchors,
        onNearestX: _this._updateTooltip,
        opacity: 0
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_renderTooltip", function (values) {
      var tooltipValueFormat = _this.props.tooltipValueFormat;
      var groupIdx = "x",
        valueIdx = "y";
      var hoveredValue = _this.state.hoveredValue;
      var tootipValues = hoveredValue !== undefined ? values.map(function (series) {
        return series.filter(function (item) {
          return item[groupIdx] === hoveredValue[groupIdx];
        })[0];
      }).filter(function (e) {
        return e;
      }).reverse() : [];
      return hoveredValue ? /*#__PURE__*/_react.default.createElement(_reactVis.Hint, {
        value: hoveredValue
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "rv-hint__content"
      }, /*#__PURE__*/_react.default.createElement("table", null, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("td", {
        colSpan: 3
      }, /*#__PURE__*/_react.default.createElement("strong", null, tootipValues[0][groupIdx])))), /*#__PURE__*/_react.default.createElement("tbody", null, tootipValues.map(function (val, i) {
        return /*#__PURE__*/_react.default.createElement("tr", {
          key: i
        }, /*#__PURE__*/_react.default.createElement("td", null, val.group), /*#__PURE__*/_react.default.createElement("td", null, tooltipValueFormat(val[valueIdx])));
      }))))) : null;
    });
    _defineProperty(_assertThisInitialized(_this), "_processData", function () {
      var _this$props = _this.props,
        data = _this$props.data,
        colorMap = _this$props.colorMap;
      return data.map(function (group) {
        return group.v.map(function (bar) {
          return {
            x: bar.k,
            y: bar.v,
            group: group.k,
            color: colorMap ? colorMap[group.k] : defaultColorScale(group.k)
          };
        });
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_updateTooltip", function (val) {
      _this.setState({
        hoveredValue: val
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_clearTooltip", function () {
      _this.setState({
        hoveredValue: undefined
      });
    });
    return _this;
  }
  _createClass(LineChart, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        height = _this$props2.height,
        width = _this$props2.width,
        margin = _this$props2.margin,
        markSize = _this$props2.markSize,
        domainX = _this$props2.domainX,
        domainY = _this$props2.domainY,
        axisTitleX = _this$props2.axisTitleX,
        axisTitleY = _this$props2.axisTitleY,
        axisTypeX = _this$props2.axisTypeX,
        tickLabelAngleX = _this$props2.tickLabelAngleX,
        tickLabelAngleY = _this$props2.tickLabelAngleY,
        tickFormatX = _this$props2.tickFormatX,
        tickFormatY = _this$props2.tickFormatY,
        tickTotalX = _this$props2.tickTotalX,
        tickTotalY = _this$props2.tickTotalY,
        showGridLines = _this$props2.showGridLines,
        curve = _this$props2.curve;
      var values = this._processData();
      return /*#__PURE__*/_react.default.createElement(_reactVis.XYPlot, {
        width: width,
        height: height,
        margin: margin,
        xDomain: domainX,
        yDomain: domainY,
        xType: axisTypeX,
        onMouseLeave: this._clearTooltip
      }, showGridLines ? /*#__PURE__*/_react.default.createElement(_reactVis.HorizontalGridLines, null) : null, values.map(function (bar, i) {
        return /*#__PURE__*/_react.default.createElement(_reactVis.LineMarkSeries, {
          data: bar,
          size: markSize,
          key: i,
          colorType: "literal",
          curve: curve
        });
      }), /*#__PURE__*/_react.default.createElement(_reactVis.XAxis, {
        title: axisTitleX,
        tickLabelAngle: tickLabelAngleX,
        tickTotal: tickTotalX,
        tickFormat: tickFormatX
      }), /*#__PURE__*/_react.default.createElement(_reactVis.YAxis, {
        title: axisTitleY,
        tickLabelAngle: tickLabelAngleY,
        tickTotal: tickTotalY,
        tickFormat: tickFormatY
      }), this._renderTooltipAnchor(values), this._renderTooltip(values));
    }
  }]);
  return LineChart;
}(_react.Component);
_defineProperty(LineChart, "propTypes", {
  data: _propTypes2.propTypeGroupedSeries.isRequired,
  colorMap: _propTypes.default.object,
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  margin: _propTypes2.propTypeMargin,
  markSize: _propTypes.default.number,
  showGridLines: _propTypes.default.bool,
  tickLabelAngleX: _propTypes.default.number,
  tickLabelAngleY: _propTypes.default.number,
  tickFormatX: _propTypes.default.func,
  tickFormatY: _propTypes.default.func,
  tickTotalX: _propTypes.default.number,
  tickTotalY: _propTypes.default.number,
  tooltipValueFormat: _propTypes.default.func,
  domainX: _propTypes.default.array,
  domainY: _propTypes.default.array,
  axisTitleX: _propTypes.default.string,
  axisTitleY: _propTypes.default.string,
  axisTypeX: _propTypes.default.oneOf(["ordinal", "linear", "time"]),
  curve: _propTypes.default.oneOf(["curveBasis", "curveCardinal", "curveLinear", "curveMonotoneX", "curveMonotoneY", "curveNatural", "curveStep", "curveStepAfter", "curveStepBefore"])
});
_defineProperty(LineChart, "defaultProps", {
  width: 800,
  height: 400,
  margin: {
    left: 50,
    right: 50,
    top: 50,
    bottom: 50
  },
  showGridLines: true,
  tickLabelAngleX: 0,
  tickLabelAngleY: 0,
  tickFormatX: function tickFormatX(t) {
    return t;
  },
  tickFormatY: function tickFormatY(t) {
    return t;
  },
  tooltipValueFormat: function tooltipValueFormat(v) {
    return v;
  },
  axisTypeX: "ordinal"
});
var _default = (0, _empty.withEmptyView)(LineChart);
exports.default = _default;